import { render, staticRenderFns } from "./caracteristics.vue?vue&type=template&id=ab2dfb2c&scoped=true"
import script from "./caracteristics.vue?vue&type=script&lang=js"
export * from "./caracteristics.vue?vue&type=script&lang=js"
import style0 from "./caracteristics.vue?vue&type=style&index=0&id=ab2dfb2c&prod&scoped=true&lang=less"
import style1 from "./caracteristics.vue?vue&type=style&index=1&id=ab2dfb2c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab2dfb2c",
  null
  
)

export default component.exports